import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FolderPropertyCodes } from 'src/app/core/constantes/folder-property-codes';
import { ColumnType } from 'src/app/models/enums/column-type';
import { FilterType } from 'src/app/models/enums/filter-type';
import { FilterInfos } from 'src/app/models/server/core/filter-infos';
import { Results } from 'src/app/models/server/core/results-T';
import { SortInfos } from 'src/app/models/server/core/sort-infos';
import { Folder } from 'src/app/models/server/folder';
import { FoldersService } from 'src/app/services/http/folders.service';
import { BoxesStateService } from 'src/app/services/state/boxes-state.service';
import { ViewsStateService } from 'src/app/services/state/views-state.service';
import { BaseDatasource } from '../../base-datas-list/data-sources/base-datasource';

@Injectable()
export class BoxDatasource extends BaseDatasource {
    constructor(
        private foldersService: FoldersService,
        private boxesStateService: BoxesStateService,
        private viewsStateService: ViewsStateService
    ) {
        super();
    }

    public override countDatas(): number {
        let count: number = 0;
        this.boxesStateService.getSelectedBoxes().forEach((x) => (count += x.count));
        return count;
    }

    public override listDatas(from: number, size: number, sort: SortInfos, filters: FilterInfos[], generalFilters: FilterInfos[]): Observable<Results<Folder>> {
        // Récupère la liste des ids des bannettes selectionnées.
        let selectedBoxIds = this.boxesStateService
            .getSelectedBoxes()
            .map((x) => x.id)
            .join('|');

        if (!!!filters.find((x) => x.columnName == FolderPropertyCodes.BOX_ID) && selectedBoxIds != '') {
            let filter: FilterInfos = {
                columnName: FolderPropertyCodes.BOX_ID,
                value: selectedBoxIds,
                type: ColumnType.List,
                filterType: FilterType.ListMultiple,
                selectionMultiple: true,
            };

            filters.push(filter);
        }

        // Récupère la liste des dossiers correspondants aux bannettes selectionnées.
        return this.foldersService.folderList(this.viewsStateService.getSelectedView().id, from, size, sort, filters, generalFilters);
    }

    public override exportDatas(sort: SortInfos, filters: FilterInfos[], generalFilters: FilterInfos[]): Observable<Blob> {
        // Récupère la liste des ids des bannettes selectionnées.
        let selectedBoxIds = this.boxesStateService
            .getSelectedBoxes()
            .map((x) => x.id)
            .join('|');

        if (!!!filters.find((x) => x.columnName == FolderPropertyCodes.BOX_ID) && selectedBoxIds != '') {
            let filter: FilterInfos = {
                columnName: FolderPropertyCodes.BOX_ID,
                value: selectedBoxIds,
                type: ColumnType.List,
                filterType: FilterType.ListMultiple,
                selectionMultiple: true,
            };

            filters.push(filter);
        }

        // Récupère la liste des dossiers correspondants aux bannettes selectionnées.
        return this.foldersService.export(this.viewsStateService.getSelectedView().id, sort, filters, generalFilters);
    }

    public override isFolderContainsIntoList(folder: Folder): boolean {
        // Verifie si la bannette dans laquelle se trouve le dossier est une des bannettes sélectionnées.
        let selectedBoxIds = this.boxesStateService.getSelectedBoxes().map((x) => x.id);
        const result: boolean = selectedBoxIds.indexOf(folder.boxId) !== -1;
        return result;
    }
}
